import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0d2b5e",
      dark: "#0b1e3d",
      light: "#1a4a8a",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#60a5fa",
      dark: "#3b82f6",
      light: "#93c5fd",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f0f4f8",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 500,
          borderRadius: 8,
        },
        containedPrimary: {
          background: "linear-gradient(135deg, #0d2b5e 0%, #1a4a8a 100%)",
          boxShadow: "0 2px 8px rgba(13,43,94,0.25)",
          "&:hover": {
            background: "linear-gradient(135deg, #0b1e3d 0%, #0d2b5e 100%)",
            boxShadow: "0 4px 12px rgba(13,43,94,0.35)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 10 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 10 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0d2b5e",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": { color: "#0d2b5e" },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#0b1e3d",
          color: "#ffffff",
          fontWeight: 600,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 6 },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 12 },
      },
    },
  },
});

export default theme;
